import React from "react";
import "./App.css";
import "./styles/brand.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HashScroll from "./components/HashScroll";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Quote from "./pages/Quote";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import ProtectionCenter from "./pages/ProtectionCenter";
import BasicLeadForm from "./pages/BasicLeadForm";
import ProtectionProfile from "./pages/ProtectionProfile";
import Admin from "./pages/Admin";
import CampaignLanding from "./pages/CampaignLanding";
import CallbackRequest from "./pages/CallbackRequest";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <HashScroll />
        <Header />
        <main className="flex-grow">
          <Routes>
            {/* Legacy route redirects → Protection Center
                (Home, Quote, Contact components remain imported above for rollback.) */}
            <Route path="/" element={<Navigate to="/protection-center" replace />} />
            <Route path="/quote" element={<CampaignLanding />} />
            <Route path="/quote/callback" element={<CallbackRequest />} />
            <Route path="/contact" element={<Navigate to="/protection-center" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/protection-center" element={<ProtectionCenter />} />
            <Route path="/protection-center/start/:coverageType" element={<BasicLeadForm />} />
            <Route path="/protection-center/profile/:coverageType" element={<ProtectionProfile />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster richColors position="top-right" closeButton />
    </div>
  );
}

export default App;
